export const ROUTES = {
  ACCESS_CONTROL: "/access-control",
  ACCESS_CONTROL_TAB: "/access-control/:tab",
  LOGIN: "/login",
  ROOT: "/",
  PROFILE: "/profile",
  AGENT: "/agent",
  AGENT_TAB: "/agent/:tab",
  BUS: "/bus",
  BUS_TAB: "/bus/:tab",
  DATABASE: "/database",
  DATABASE_TAB: "/database/:tab",
  TRIP: "/trip",
  TRIP_TAB: "/trip/:tab",
  USER: "/user",
  USER_TAB: "/user/:roleId",
  TICKET: "/ticket",
  TICKET_TAB: "/ticket/:tab",
  AUDIT: "/audit",
  AUDIT_TAB: "/audit/:tab",
  REPORT: "/report",
  REPORT_TAB: "/report/:tab",
  TICKET_RULE_REGULATIONS: "/rules-regulations",
  ERCA: "/erca",
  ERCA_TAB: "/erca/:tab",
  TICKET_PRINT: "/ticket-print/:ticketId",
  BUS_RENTAL: "/bus-rental",
  BUS_RENTAL_TAB: "/bus-rental/:tab",
  B2b_BOOKING_PRINT: "/receipt-print/:ticketId",
  ERP_INTEGRATION: "/erp-integration",
  MOLT_INTEGRATION: "/molt-integration",
};
